import './style/index.css';
import 'bootswatch/dist/superhero/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Col, Row, Container } from 'reactstrap';
import StickyNav from './sticky-nav';
import Note from './note';
import notes from './notes';

const App = () => {
  return (
    <Container fluid>
      <Row>
        <Col md="2">
          <StickyNav selector=".note.card" links={notes.map((n) => n.title)} />
        </Col>
        <Col md="10">
          {notes.map(({ title, content }, i) => {
            return (
              <Note key={i} title={title}>
                {content}
              </Note>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
};

ReactDOM.render(<App />, document.querySelector('#root'));
